module.exports = {
	"next": "suivant",
	"skip": "Créer directement votre Cozy",
	"cancel": "annuler",
	"back": "retour",
	"sign up": "s'enregistrer",
	"add email": "ajouter un compte email",
	"welcome": "c'est parti !",
	"confirm": "valider",
	"step preset": "réglages",
	"step import": "importer des données",
	"step email settings": "configurer votre email",
	"preset email": "email",
	"preset email tip": "Cette adresse email sera utilisée pour vous envoyer un message lors d'une récupération de mot de passe.",
	"preset name": "nom",
	"preset name tip": "Le nom sous lequel vous apparaitrez dans les messages de partages et les invitations calendrier.",
	"preset password": "mot de passe",
	"preset password tip": "Un mot de passe fort d'au moins 8 caractères (les caractères spéciaux sont recommandés).",
	"preset timezone": "fuseau horaire",
	"preset timezone tip": "Votre fuseau horaire est utilisé pour afficher correctement les événements dans votre calendrier.",
	"preset opt-in help": "Je souhaite aider Cozy à améliorer la plateforme en transmettant des données statistiques anonymes relatives à mon utilisation.",
	"preset opt-out newsletter": "Je souhaite être informé par Cozy des évolutions du produit (recommandé).",
	"import from google": "importer mes données depuis mon compte Google",
	"import google account": "Synchroniser votre compte Gmail & importer mes calendriers, contacts et photos depuis Google",
	"import google account tip": "Vous devez vous authentifier sur votre compte Google pour autoriser Cozy à accéder aux informations hébergées chez Google",
	"leave google title": "Importez vos données dans Cozy",
	"leave google help me": "Je n'ai pas compris, aidez-moi !",
	"leave google sign in content": "Authentifiez-vous sur votre compte Google pour autoriser votre Cozy à accéder à vos informations. Vous obtiendrez une suite de caractères complexe. Copiez-la.",
	"leave google sign in": "S'authentifier chez Google",
	"leave google code content": "Puis, copiez-collez le code extrait de la popup dans ce champ :",
	"leave google code": "jeton Google",
	"leave google url doc": "https://docs.cozy.io/fr/mobile/import-google.html",
	"leave google choice": "Sélectionnez les données hébergées chez Google à importer :",
	"leave google choice sync gmail": "GMail - Accédez à vos emails depuis Cozy",
	"leave google choice contacts": "Contacts Google - Copier sur mon Cozy",
	"leave google choice calendar": "Calendriers Google - Copier sur mon Cozy",
	"leave google choice photos": "Photos Google - Copier sur mon Cozy",
	"leave google confirm": "Importer les données",
	"import error": "Une erreur s'est produite durant l'importation de vos données. Veuillez réessayer depuis l'application dédiée.",
	"login welcome": "Bienvenue %{username}",
	"login enter your password": "Entrez votre mot de passe pour accéder à votre Cozy",
	"login password": "mot de passe",
	"login submit": "s'authentifier",
	"login auth success": "Authentification réussie, entrons !",
	"login recover": "Mot de passe oublié ? Envoyez-moi un email de restauration.",
	"login recover again": "Vous ne l'avez pas reçu ? Renvoyez-le moi.",
	"login recover sent title": "Email envoyé",
	"login recover sent message": "Un email contenant les instructions pour restaurer votre mot de passe vous a été envoyé.",
	"login recover error title": "Une erreur s'est produite à l'envoi du mail",
	"login recover error message": "Une erreur s'est produite à l'envoi du message de récupération du mot de passe. Veuillez vérifier le bon fonctionnement de votre MTA ou contactez l'administrateur de votre serveur.",
	"login wrong password title": "Mot de passe erroné",
	"login wrong password message": "Le mot de passe que vous avez saisi n'est pas correct, veuillez réessayer.",
	"reset welcome": "Restauration du mot de passe",
	"reset enter your password": "%{username}, entrez un nouveau mot de passe pour restaurer votre accès",
	"reset password": "mot de passe",
	"reset submit": "restaurer votre mot de passe",
	"reset auth success": "mot de passe restauré",
	"reset wrong password title": "Votre mot de passe n'a pas pu être restauré",
	"reset wrong password message": "Le mot de passe que vous avez entré n'est pas correct, ou votre jeton de restauration a expiré.",
	"setup title": "Nous préparons votre Cozy…",
	"setup message": "Vous y être presque ! Dans quelques instants vous pourrez accéder à votre Cozy et reprendre le contrôle de vos données.",
	"setup on mobile title": "Synchronisez vos données avec votre Android !",
	"setup on mobile message": "Téléchargez l'app mobile Cozy sur Google Play :",
	"welcome title": "Félicitations ! Vous venez de reprendre le contrôle de vos données !",
	"welcome message": "Avec Cozy, vous pouvez désormais stocker vos données dans votre propre cloud personnel. Contrairement aux autres services cloud, aucune de vos données ne sera analysée ou exploitée !"
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/locales/fr.json
 ** module id = 30
 ** module chunks = 1
 **/